{
  "label": "Etiquetas",
  "add": "Agregar etiqueta",
  "remove": "Quitar",
  "search_or_create": "Buscar o crear etiqueta…",
  "empty": "Sin etiquetas todavía",
  "create_named": "Crear \"{name}\"",
  "confirm_delete": "¿Eliminar la etiqueta \"{name}\" de todo el equipo?",
  "error_generic": "No se pudo actualizar las etiquetas.",
  "error_permission": "Solo los administradores del equipo pueden crear o borrar etiquetas."
}
